export const MobileDirectionMenuEnum = Object.freeze({
    addPoi: 'addPoi',
    settingTime: 'settingTime',
    moreOption:'moreOption'
});